import { RiskMatrixTranslation } from 'app/area/risk-matrix-administration/constants';
import { getAxisDescription } from 'app/area/risk-matrix-administration/mappers/map-to-risk-matrix-definition';
import { RiskMatrixAxis } from 'app/area/risk-matrix-administration/types-store';
import React from 'react';
import { MeatballMenu } from 'ui';
import styles from './risk-matrix-meatball.scss';

interface MeatballProps {
  items: RiskMatrixAxis[];
  onClick: (() => void)[];
  translation: RiskMatrixTranslation;
}

export const RiskMatrixMeatball = ({ items, onClick, translation }: MeatballProps) =>
  !items || items.length === 0
    ? null
    : <MeatballMenu id="codetable-sticky-header-meatballmenu" className={styles.meatball} closeAfterClick={true}>
      {
        items.map((axis, index) =>
          <li key={index}>
            <button type="button" className="dropdown-item"
              onClick={onClick[index]}>
              {getAxisDescription(axis.codetableId, translation)}
            </button>
          </li>)
      }
    </MeatballMenu>;
